// PDF React View
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  RELEASE_REGISTRY_DELEGATE_FAIL,
  RELEASE_REGISTRY_DELEGATE_SUCCESS,
  RELEASE_REGISTRY_INVOICES_FAIL,
  RELEASE_REGISTRY_INVOICES_SUCCESS,
  RELEASE_REQUEST_INVOICE_CODE_FAIL,
  RELEASE_REQUEST_INVOICE_CODE_SUCCESS,
} from "store/data-format/actionTypes";
const SignHSMModal = props => {
  const dispatch = useDispatch();
  const {
    isOpen,
    toggle,
    transferData,
    resetDataFunc,
    releaseFunc,
    resetReleaseFunc,
    params,
    t,
  } = props;
  const dataFormat = useSelector(state => state.dataFormat);
  const { type, releaseRegistryInvoices } = dataFormat;
  const { addToast } = useToasts();
  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen]);

  useEffect(() => {
    switch (type) {
      // SIGN HSM and release SUCCESS
      case RELEASE_REGISTRY_INVOICES_SUCCESS:
      case RELEASE_REGISTRY_DELEGATE_SUCCESS:
      case RELEASE_REQUEST_INVOICE_CODE_SUCCESS:
        addToast(t("form.submit.release.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggle();
        dispatch(resetDataFunc(params));
        dispatch(resetReleaseFunc());
        break;
      case RELEASE_REGISTRY_INVOICES_FAIL:
      case RELEASE_REGISTRY_DELEGATE_FAIL:
      case RELEASE_REQUEST_INVOICE_CODE_FAIL:
        addToast(t("form.submit.release.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetReleaseFunc());
        break;
      default:
        break;
    }
  }, [type]);

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "30%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>{t("signHSM.title")}</Label>
        </ModalHeader>
        <ModalBody>
          <Label className="font-size-14">{t("signHSM.content")}</Label>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="primary"
            // disabled={isDisableButton}
            className="me-2 btn-label"
            disabled={releaseRegistryInvoices.loading}
            onClick={() => {
              dispatch(releaseFunc(transferData.id));
            }}
          >
            <i className="fas fa-signature label-icon" />
            {t("signHSM.sign")}
          </Button>
          <Button
            type="button"
            color="danger"
            className="me-2"
            onClick={toggle}
          >
            {t("signHSM.close")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

SignHSMModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  transferData: PropTypes.any,
  resetDataFunc: PropTypes.any,
  releaseFunc: PropTypes.func,
  resetReleaseFunc: PropTypes.func,
  t: PropTypes.any,
  params: PropTypes.any,
};

export default SignHSMModal;
